<template>
  <div id="app">

      <el-container style="margin:0px;padding:0px;">
        <el-aside width="300px" style="border-right: 1px solid #e7e9eb;
          position: relative;
          outline: none;
          color: #767c85;">
          
            <el-row type="flex" style="padding-bottom:5px;">
              <el-col :span="14" >表单/数据: {{this.subjectFormData.length}}/{{this.totalsubjectFormAnswerCount}}
              </el-col>
              <el-col :span="10" style="text-align:right"><el-link  type="primary" :underline="false" icon="el-icon-plus" @click='openFormTalbeDialog'>添加表单</el-link></el-col>
            </el-row>
            <el-row type="flex" style="padding-bottom:5px;">
              <el-col :span="24">
                
                  <el-link icon="el-icon-tickets" v-for="(item,index) in this.weixinconsents" 
                          @click="showWeixinConsent(item.weixinconsentid)" :key="index" :underline="false" >{{item.formname}}({{item.submitteddate}})</el-link>
                  
              
              </el-col>
            </el-row>
            <div style="padding-right:8px;">
              <el-input
              v-model="search"
              size="media"
              placeholder="输入关键字搜索"
              clearable/>
            </div>

            <!-- 左边的数据显示 -->
            <el-table 
              v-loading="loadingsubjectFormData"
              :data="computedSubjectFormData"  
              :show-header="false"  
              row-key="id"
              :tree-props="{children: 'answers', hasChildren: 'hasChildren'}" 
              ref="subjectformdatatable"
              @row-click="subjectFormData_Click"
              
              :row-class-name="tableRowClassName">
            
              <el-table-column prop="formname" label="表单" >
                <template v-slot="scope">
                  <template v-if="scope.row.type == 'form'">
                    {{scope.row.formname | ellipsis}}
                    <template v-if="scope.row.answercount != 0">
                      ({{ scope.row.answercount }})
                    </template>
                    <br>
                    <el-tag size="mini" v-if="scope.row.category||'' != ''">{{scope.row.category}}</el-tag>
                  </template>

                  <template v-if="scope.row.type == 'answer'">
                    {{scope.row.submitteddate}}<br>
                    <span style="color:#aabbcc;padding-left:40px;">{{$moment(scope.row.submitteddate).fromNow()}}</span>
                   
                  </template>

                  
                </template>
              </el-table-column>

              <el-table-column label="" align="right" width="60">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.type=='form' && subjectInfo.weixinstatus =='online'" icon="el-icon-s-promotion" @click.stop="openSendWeixinForm(scope.row)" :underline="false" style="font-size:18px;padding-right:3px;"></el-link>
                  <el-link v-if="scope.row.type=='form' && scope.row.answercount!=0 " icon="el-icon-s-grid" @click.stop="showFormGrid(scope.row)" :underline="false" style="font-size:18px;"></el-link>
                  <el-link v-show="scope.row.id == currentRowID"  v-if="scope.row.type=='answer' || scope.row.answercount==0 " icon="el-icon-delete" @click.stop="RemoveFormorAnswer(scope.row)" :underline="false" style="font-size:18px;"></el-link>
                </template>
              </el-table-column>
            
            </el-table>
       
      
          <el-dialog title="添加表单" :visible.sync="formTableVisible">
             <div style="padding-right:8px;">
              <el-input
              v-model="search4addform"
              size="media"
              placeholder="可输入表单名称、标签进行搜索"
              clearable/>
            </div>

            <el-table 
            v-loading="loadingforms"
            :data="tabledata_form.filter(data=> !this.search4addform ||
                                        data.name.toLowerCase().includes(this.search4addform.toLowerCase()) ||
                                        (data.tags||'').toLowerCase().indexOf(this.search4addform.toLowerCase()) != -1 
                                        )" 
            :show-header="false" 
            max-height="500">
              <el-table-column prop="name" label="表单名称">
                <template slot-scope="scope">

                  {{scope.row.name}}
                  <span v-if="(scope.row.tags|| []).length != 0">
                  <el-tag size="mini"  v-for="(item,index) in scope.row.tags.split(',')" :key="index">{{item}}</el-tag>
                  </span>
                
                </template>
              </el-table-column>
              <el-table-column label="操作" align="right">
                <template slot-scope="scope">
          
                  <el-link icon="el-icon-plus" @click="addformtosubject(scope.row)" :underline="false" style="font-size:20px;padding-right:8px"></el-link>
                  
            
                </template>
              </el-table-column>
            </el-table>
            <br>
          </el-dialog>


          <el-dialog :title="this.weixinform.formname + '收集'" :visible.sync="weixinform.dialog" >

            <el-tabs value="send" >
              <el-tab-pane label="收集记录" name="send">
                  <el-collapse value="1">
                    <el-collapse-item name="1">
                        <template slot="title">
                          <span style="font-weight:normal">今&nbsp;&nbsp;天 ( 未填写：{{computedSendList[0].uncompletedcount}} | 总数: {{computedSendList[0].list.length}} )</span>
                        </template>
                        <el-table v-loading="loadingsendlist"
                        :data="computedSendList[0].list" :show-header="false" max-height="450" >
                          <el-table-column prop="formname" label="表单名称">
                            <template slot-scope="scope">
                              {{scope.row.startdate}}
                              <br>
                              <span style="color:#aabbcc">{{$moment(scope.row.startdate).fromNow()}} 结束于{{scope.row.enddate}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="操作" align="right" width="150">
                            <template slot-scope="scope">
                              <div v-if="scope.row.completeddate ==='' || scope.row.completeddate ===undefined || scope.row.completeddate ==null" >
                                <el-link type="primary" icon="el-icon-phone-outline" @click="remindWeixinForm(scope.row)" 
                                :underline="false" style="font-size:14px;padding-right:8px">提醒</el-link>
                                <br>
                                <el-link icon="el-icon-delete" @click="deleteWeixinForm(scope.row.weixinformid)" 
                                :underline="false" style="font-size:14px;padding-right:8px">删除</el-link>
                              </div>
                              <div v-else>
                                <span style="font-size:14px;padding-right:8px">已提交</span>
                                <br>
                                <span style="font-size:12px;">{{scope.row.completeddate}}</span>
                              </div>
                        
                            </template>
                          </el-table-column>
                        </el-table>
                    </el-collapse-item>
                    <el-collapse-item title="7天内" name="2">
                        <template slot="title">
                          <span style="font-weight:normal">7天内 ( 未填写：{{computedSendList[1].uncompletedcount}} | 总数: {{computedSendList[1].list.length}} )</span>
                        </template>
                        <el-table 
                        v-loading="loadingsendlist"
                        :data="computedSendList[1].list" :show-header="false" max-height="450" >
                          <el-table-column prop="formname" label="表单名称">
                            <template slot-scope="scope">
                              {{scope.row.startdate}}
                              <br>
                              <span style="color:#aabbcc">{{$moment(scope.row.startdate).fromNow()}} 结束于{{scope.row.enddate}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="操作" align="right" width="150">
                            <template slot-scope="scope">
                              <div v-if="scope.row.completeddate ==='' || scope.row.completeddate ===undefined || scope.row.completeddate ==null" >
                                <el-link type="primary" icon="el-icon-phone-outline" @click="remindWeixinForm(scope.row)" 
                                :underline="false" style="font-size:14px;padding-right:8px">提醒</el-link>
                                <br>
                                <el-link icon="el-icon-delete" @click="deleteWeixinForm(scope.row.weixinformid)" 
                                :underline="false" style="font-size:14px;padding-right:8px">删除</el-link>
                              </div>
                              <div v-else>
                                <span style="font-size:14px;padding-right:8px">已提交</span>
                                <br>
                                <span style="font-size:12px;">{{scope.row.completeddate}}</span>
                              </div>
                        
                            </template>
                          </el-table-column>
                        </el-table>
                    </el-collapse-item>
                    <el-collapse-item title="更早" name="3">
                        <template slot="title">
                          <span style="font-weight:normal">更&nbsp;&nbsp;早 ( 未填写：{{computedSendList[2].uncompletedcount}} | 总数: {{computedSendList[2].list.length}} )</span>
                        </template>
                      <el-table v-loading="loadingsendlist"
                      :data="computedSendList[2].list" :show-header="false" max-height="450" >
                          <el-table-column prop="formname" label="表单名称">
                            <template slot-scope="scope">
                              {{scope.row.startdate}}
                              <br>
                              <span style="color:#aabbcc">{{$moment(scope.row.startdate).fromNow()}} 结束于{{scope.row.enddate}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="操作" align="right" width="150">
                            <template slot-scope="scope">
                              <div v-if="scope.row.completeddate ==='' || scope.row.completeddate ===undefined || scope.row.completeddate ==null" >
                                <el-link type="primary" icon="el-icon-phone-outline" @click="remindWeixinForm(scope.row)" 
                                :underline="false" style="font-size:14px;padding-right:8px">提醒</el-link>
                                <br>
                                <el-link icon="el-icon-delete" @click="deleteWeixinForm(scope.row.weixinformid)" 
                                :underline="false" style="font-size:14px;padding-right:8px">删除</el-link>
                              </div>
                              <div v-else>
                                <span style="font-size:14px;padding-right:8px">已提交</span>
                                <br>
                                <span style="font-size:12px;">{{scope.row.completeddate}}</span>
                              </div>
                        
                            </template>
                          </el-table-column>
                        </el-table>
                    </el-collapse-item>
                  </el-collapse>
                  
                  <div style="float:right;padding-top:5px;">
                    <el-button type="primary" style="align:right;" @click="newSendWeixinFormIMM">新增</el-button>
                  </div>
              </el-tab-pane>
              <el-tab-pane label="计划" name="plan">

                  <el-table v-loading="loadingplanlist"
                  :data="frequency.planlist" :show-header="false" max-height="320">
                    <el-table-column prop="formname" label="表单名称">
                      <template slot-scope="scope">
                        {{scope.row.startdate}} - {{scope.row.enddate}}
                        <br>
                        {{scope.row.abstract==""?"不重复":scope.row.abstract}}
                        <span v-if="scope.row.until || '' !=''">
                          {{new Date(scope.row.until).getFullYear() + '-' + (new Date(scope.row.until).getMonth()+1) +'-' +new Date(scope.row.until).getDate()}} 结束重复
                        </span>
                        
                      
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="right" width="200">
                      <template slot-scope="scope">
                          {{scope.row.lastplandate}}
                          <br>
                          {{scope.row.lastplandate||'' != ''?$moment(scope.row.lastplandate).fromNow():''}} 
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="right" width="150">
                      <template slot-scope="scope">
                         
                          <el-link icon="el-icon-delete" @click="deleteSubjectFormPlan(scope.row.subjectformplanid)" 
                          :underline="false" style="font-size:14px;padding-right:8px">删除</el-link>
                        
                      </template>
                    </el-table-column>
                  </el-table>



                  <el-form ref="sendweixinform" :model="frequency.form" label-width="110px" :rules="frequency.rules" style="padding-top:10px">
                      <el-form-item label="填写时间" prop="time">
                        <span slot="label">
                          <i class="el-icon-time"></i>
                        </span>
                        <el-col :span="24">
                          <el-date-picker 
                            type="datetimerange" 
                            placeholder="选择日期时间" 
                            v-model="frequency.form.time"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss"
                            start-placeholde="开始日期时间"
                            end-placeholde="结束日期时间"
                            :default-time="['00:00:00','23:59:59']"
                            
                            :picker-options="frequency.pickerOptions"
                          >
                          </el-date-picker>
                        </el-col>
                      </el-form-item>
                      <el-form-item v-if="this.frequency.form.time ||'' != ''">
                        <span slot="label">
                          <i class="el-icon-refresh-right"></i>
                        </span>
                        
                        <el-dropdown @command="setfrequency" trigger="click">
                            <span class="el-dropdown-link">
                              
                              <el-link v-if="frequency.form.plantype != 0 " :underline='false' type="primary">{{computedAbstract}}</el-link>
                              <el-link v-else :underline='false' type="primary">设置重复</el-link>
                              
                              
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item v-for="(item,index) in frequency.list" :key="index" 
                                  :command="frequencyCommand(item)" 
                                  :icon="(frequency.form.plantype == item.plantype)?'el-icon-check':''"
                              >
                                <span :style="(frequency.form.plantype == item.plantype)?'':'padding-left:20px;'">{{item.abstract}} </span>
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                          <div v-if="frequency.form.plantype == 99" style="padding-bottom:25px;">
                     

                            <!-- <el-form ref="sendweixinform1" :rules="frequence.rules"> -->
                              <el-form-item label="重复频率: 每">
                                <el-col :span="5"><el-input v-model="frequency.form.intervalnum"></el-input>
                                </el-col>
                                <el-col :span="8">
                                  <el-select v-model="frequency.form.freq">
                                    <el-option label="天" value="DAILY"></el-option>
                                    <el-option label="周" value="WEEKLY"></el-option>
                                    <el-option label="个月" value="MONTHLY"></el-option>
                                    <el-option label="年" value="YEARLY"></el-option>
                                  </el-select>
                                </el-col>
                              </el-form-item>
                              <el-form-item label="重复时间" v-if="frequency.form.freq=='WEEKLY'" prop="byday">

                                <el-checkbox-group v-model="frequency.form.byday" size="small">
                                  <el-checkbox-button label="MO">一</el-checkbox-button>
                                  <el-checkbox-button label="TU">二</el-checkbox-button>
                                  <el-checkbox-button label="WE">三</el-checkbox-button>
                                  <el-checkbox-button label="TH">四</el-checkbox-button>
                                  <el-checkbox-button label="FR">五</el-checkbox-button>
                                  <el-checkbox-button label="SA">六</el-checkbox-button>
                                  <el-checkbox-button label="SU">日</el-checkbox-button>
                                </el-checkbox-group>
                              </el-form-item>
                            
                            <!-- </el-form> -->
                          </div>
                          <div v-if="frequency.form.plantype != 0">
                            <el-date-picker v-model="frequency.form.until" 
                              type="date" 
                              placeholder="设置结束重复"
                              value-format="yyyy-MM-dd"
                              format="yyyy-MM-dd"
                              :picker-options="frequency.pickerOptionsEndDate"
                            >
                            </el-date-picker>(结束重复)
                          </div>
                      </el-form-item>
          
                    </el-form>

                    <div style="float:right;padding-top:5px;">
                      <el-button type="primary" style="align:right;" @click="newSendWeixinFormPlan">新增计划</el-button>
                    </div>
              </el-tab-pane>
            </el-tabs>



            
            <br>
        
            
            
          </el-dialog>
      
        </el-aside>
        
        <el-main style="margin:0px;padding:0px;padding-left:20px;">

          <!-- datagrid -->
          <el-container style="margin:0px;padding:0px;" v-if="this.form.mode == 'grid'">
            <el-tabs v-model="activeName" tab-position="top" height="auto" @tab-click="tabClick">
              <el-tab-pane label="数据集" name="first">
                <el-table
                    v-loading="loadinganswerList"
                    :data="answerList"
                    style="width:100%">
                    <el-table-column type="index" fixed>
                    </el-table-column>
                    <el-table-column
                      fixed
                   
                      label="日期"
                      width="200">
                      <template v-slot="scope">
                        {{scope.row.submitteddate}}<br>
                        <span style="color:#aabbcc">{{$moment(scope.row.submitteddate).fromNow()}}</span>
                        <!-- {{scope.row.modifieddate||'' ==''?scope.row.createddate:scope.row.modifieddate}} -->
                      </template>
                    </el-table-column>
                    <el-table-column 
                    v-for="question in questions"

                      :label="question.caption"
                      :width="question.width || 150">
                      <template slot-scope="scope">
                          <template v-if="question.datatype=='xml'">
                            <el-popover
                              placement="right"
                              width="400"
                              trigger="click">
                              <template>
                                    <ul v-if="question.inline=='1'" style="list-style:none;">
                                      <li v-for="field in question.fields" style="height:35px;">
                                        <el-checkbox :checked='getChecked(scope.row[question.name], field.name)' disabled>{{field.caption}}</el-checkbox>
                                      </li>
                                    </ul>

                                    <el-table v-if="question.inline=='0'" :data="scope.row[question.name] ||[]" border height="300">
                                      <el-table-column 
                                      v-for="field in question.fields"
                                      :prop="field.name"
                                      :label="field.caption">
                                          <template slot-scope="scope">
                                              <template v-if="field.datatype==='enum'">
                                                <template v-for="eu in field.enum">
                                                  <span v-if="eu.name==scope.row[field.name]">{{eu.caption}}</span>
                                                </template>
                                              </template>
                                              <span v-if="field.datatype=='string' || field.datatype=='int'">{{ scope.row[field.name] || '' }}</span>
                                          </template>
                                      </el-table-column>
                                    </el-table>
                              </template>
                              <template v-if="question.inline=='1'">
                                <el-link slot="reference">{{getAllChecked(scope.row[question.name], question)}}</el-link>
                              </template>
                              <i v-if="question.inline!='1'" class="el-icon-more" slot="reference"></i>
                            </el-popover>
                          </template>
                        <template v-if="question.datatype==='enum'">
                          <template v-for="item in question.enum">
                            <span v-if="item.name==scope.row[question.name]">{{item.caption}}</span>
                          </template>
                        </template>
                        <span v-if="question.datatype=='string' || question.datatype=='int'">{{ scope.row[question.name] || '' }}</span>
                      </template>

                    </el-table-column>
                    
                    <el-table-column
                      fixed="right"
                      label="操作"
                      width="100">
                      <template slot-scope="scope">
                        <el-button @click="showAnswer(scope.row)" type="text" size="small">查看</el-button>
                      </template>
                    </el-table-column>
                  </el-table>

                  <el-drawer
                    title="我是标题"
                    size = "50%"
                    :visible.sync="drawerSmartTable"
                    :with-header="false">
                    <span>SmartTable</span>
                  </el-drawer>

              </el-tab-pane>
              <el-tab-pane label="折线图" name="second">
                <el-radio-group v-model="radio1" @change="draw1">
                  <el-radio v-for="question in questions" v-if="question.datatype!='xml' && question.datatype !='enum'" :label="question.name" :key="question.name">{{question.caption}}</el-radio>
                </el-radio-group>

                <div ref="myChart" style="width:600px;height:400px;"></div>
              </el-tab-pane>
              <!-- <el-tab-pane label="散点图" name="third">配置管理</el-tab-pane> -->
            </el-tabs>

          </el-container>
          <!-- 保持表单 -->
          <el-container v-else>
            <el-header v-show="this.form.formid || '0' !='0' " style="height:50px;">
              <el-row type="flex" align="middle">
                <el-col>
                    <div>
                        <el-button type="primary" @click="onSave">保存</el-button> 
                        <span v-if="this.form.modifieddate != ''"
                          style="font-size:14px;"
                        >
                          最后更新于 {{this.form.modifieddate}}
                          <span style="color:#aabbcc">{{$moment(this.form.modifieddate).fromNow()}}</span>
                        </span>
                    </div>
                </el-col>
                <el-col style="text-align:right">
                    <el-link v-if="this.form.answerid || 0!=0" :underline="false" @click="openVersion"><i class="fa fa-history"></i>&nbsp;历史数据</el-link>

                </el-col>
              </el-row>
            </el-header>
            <el-main style="margin:0px;padding:0px;padding-top:5px;overflow:hidden;">
                <iframe ref="iframe" :src="editorUrl" frameborder="0" scrolling="yes" name="iframe" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
            </el-main>
            


          </el-container>
          <el-drawer
            title="我是标题"
            size = "50%"
            :visible.sync="drawer"
            :with-header="false">
            <iframe ref="iframe" :src="viewUrl" frameborder="0" scrolling="yes" name="iframe" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
          </el-drawer>

           <el-drawer
            title="查看历史版本"
            size = "60%"
            direction ="rtl"
            :visible.sync="drawerversion"
            :with-header="false"
            >

                <el-table
                  :data="history"
                  highlight-current-row
                  @row-click="history_rowclick"
                  style="width:100%"
                  max-height="200"
                >
                  <el-table-column
                    label=""
                    type="index"
                    :index="indexMethod">
                  </el-table-column>
                  <el-table-column prop="createddate" label="时间" >
                    <template slot-scope="scope">
                      {{scope.row.createddate}}&nbsp;
                      <span style="color:#aabbcc">{{$moment(scope.row.createddate).fromNow()}}</span>
                      
                    </template>
                    
                  </el-table-column>
                  <el-table-column prop="username" label="最近" width="100px">
                  </el-table-column>
                  <el-table-column prop="operation" label="操作" >
                    <i class="fa fa-eye"></i>&nbsp;点击查看
                  </el-table-column>
                </el-table>
                <br>
            <iframe ref="iframeversion" :src="viewVersionUrl" frameborder="0" scrolling="yes" name="iframeversion" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
          </el-drawer>
        </el-main>

       
      
      </el-container>
 
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      subjectInfo:{},
      formTableVisible:false,
      editorUrl:"",
      subjectid:this.$route.query['id'],
      totalsubjectFormAnswerCount:0,
      subjectFormData:[],
      loadingsubjectFormData:true,
      search:'',
      search4addform:'',
      tabledata_form:[],
      loadingforms:true,
      form: {
        formid: this.$route.query['formid'],
        answerid: '',
        xmlresult: '',
        mode:'',
        modifieddate:'',
      },
      currentRowID:'',

      questions:[],
      answerList:[],
      loadinganswerList:true,
      radio1: '',
      activeName: 'first',
      myChart:null,
      drawerSmartTable: false,
      drawer: false,
      viewUrl: '',

      weixinuser:{},
      weixinconsents:[],
      weixinform:{
        dialog:false,
        sendlist:[],
        formid:'',
        form:{
          formid:'',
          subjectid:'',
          time:'',
          startdate:'',
          enddate:'',
          typecode:'',
          openid:'',
        },
      },

      frequency:{
          planlist:[],
          form:{
            plantype:'',
            abstract:'',
            startdate:'',
            enddate:'',
            freq:'',
            intervalnum:'',
            until:'',
            byday:[],
            bymonth:0,
            bymonthday:0,
          },
          rules:{
            time:[
              {required:true,message:'请选择日期时间',trigger:'blur'}
            ],
            byday:[
              {required:true,message:'至少选择一天',trigger:'change'}
            ]
          },
          list:[],
          pickerOptions:{
            shortcuts:[{
              text:'当天',
              onClick(picker){
                const start = new Date();
                const end = new Date(start.getFullYear() + '-' + (start.getMonth()+1) + '-' + start.getDate() +' ' +'23:59:59');
                picker.$emit('pick',[start,end]);
              }
            },{
              text:'未来一天',
              onClick(picker){
                const end = new Date();
                const start = new Date();
                end.setTime(end.getTime() + 3600 *1000 *24);
                picker.$emit('pick',[start,end]);
              }
            },{
              text:'未来一周',
              onClick(picker){
                const end = new Date();
                const start = new Date();
                end.setTime(end.getTime() + 3600 *1000 *24*7);
                picker.$emit('pick',[start,end]);
              }
            },{
              text:'未来一月',
              onClick(picker){
                const end = new Date();
                const start = new Date();
                end.setTime(end.getTime() + 3600 *1000 *24*30);
                picker.$emit('pick',[start,end]);
              }
            },
            ],
          },
          pickerOptionsEndDate:{
            disabledDate(time) {
              //return time.getTime() < Date.now() - 8.64e7;   //禁用以前的日期，今天不禁用
              return time.getTime() <= Date.now();    //禁用今天以及以前的日期
            }
          },
        },
        weekday:[
          {code:'SU',name:'日'},
          {code:'MO',name:'一'},
          {code:'TU',name:'二'},
          {code:'WE',name:'三'},
          {code:'TH',name:'四'},
          {code:'FR',name:'五'},
          {code:'SA',name:'六'},
        ],

        history:[],
        loadinghistory:true,
        drawerversion:false,
        viewVersionUrl:'',

        loadingsendlist:true,
        loadingplanlist:true,
      
    };
    
  },
  computed:{
    computedStartDate(){
      return this.frequency.form.time[0];
    },
    computedTime(){
      return this.frequency.form.time;
    },
    computedPlanType(){
      return this.frequency.form.plantype;
    },
    computedAbstract(){
      let strAbstract;
      
      if(this.frequency.form.plantype != 99){

        return this.frequency.form.abstract;
      }else{

      switch(this.frequency.form.freq){
          case "DAILY":
            strAbstract = 
            "每"+ 
            (this.frequency.form.intervalnum >1?this.frequency.form.intervalnum:'')
            +"天"
            break;
          case "WEEKLY":
            strAbstract = 
            "每"+ 
            (this.frequency.form.intervalnum >1?this.frequency.form.intervalnum:'')
            +"周"
          
            let dayname ="";
            if(this.frequency.form.byday.indexOf("MO") !=-1) dayname=dayname + "一、";
            if(this.frequency.form.byday.indexOf("TU") !=-1) dayname=dayname + "二、";
            if(this.frequency.form.byday.indexOf("WE") !=-1) dayname=dayname + "三、";
            if(this.frequency.form.byday.indexOf("TH") !=-1) dayname=dayname + "四、";
            if(this.frequency.form.byday.indexOf("FR") !=-1) dayname=dayname + "五、";
            if(this.frequency.form.byday.indexOf("SA") !=-1) dayname=dayname + "六、";
            if(this.frequency.form.byday.indexOf("SU") !=-1) dayname=dayname + "日、";

            if(dayname != "") dayname = dayname.substr(0,dayname.length-1);
            strAbstract = strAbstract + dayname;
            break;
          case "MONTHLY":
            strAbstract = 
            "每"+ 
            (this.frequency.form.intervalnum >1?this.frequency.form.intervalnum:'')
            +"个月"
            break;
          case "YEARLY":
            strAbstract = 
            "每"+ 
            (this.frequency.form.intervalnum >1?this.frequency.form.intervalnum:'')
            +"年"
            break;
          default:
            break;

        }

        this.frequency.form.abstract = strAbstract;
        strAbstract = strAbstract + "(自定义)"
        
      }
      

      return strAbstract;
    },
    //受试者匹配的表单列表，供Search使用
    computedSubjectFormData(){
      return this.subjectFormData.filter(
        data => !this.search ||
                data.formname.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    computedSendList(){

      let arrysendlist = [
          {list:[],uncompletedcount:0},
          {list:[],uncompletedcount:0},
          {list:[],uncompletedcount:0},
        ];
      
      this.weixinform.sendlist.forEach(element => {
        let days = this.$moment().diff(this.$moment(element.startdate).startOf('day'), 'days');
        
        if(days ==0){
          arrysendlist[0].list.push(element);
          if((element.completeddate || "" == "") == true) {
            let count = arrysendlist[0].uncompletedcount +1;
            arrysendlist[0].uncompletedcount = count;
          }
        }
        else if(days <=7 && days >0){
          arrysendlist[1].list.push(element);
          if((element.completeddate || "" == "") == true) {
            let count1 = arrysendlist[1].uncompletedcount +1;
            arrysendlist[1].uncompletedcount = count1;
          }
        }else{
          arrysendlist[2].list.push(element);
          if((element.completeddate || "" == "") == true) {
            let count2 = arrysendlist[2].uncompletedcount +1;
            arrysendlist[2].uncompletedcount = count2;
          }
        }
        
      });
      
      return arrysendlist;
    },

  },
  methods:{
  
    subjectFormData_Click(row,event,column){
      
      this.form.mode = "edit";
      this.currentRowID = row.id;
      this.form.formid = row.formid;
      this.form.answerid = row.subjectformanswerid;
      if(row.type == "form"){
        this.form.modifieddate = "";
        this.loadForm(this.form.formid);
      }
      else if(row.type == "answer"){
        this.form.modifieddate = row.modifieddate;
        this.loadAnswer(this.form.answerid);
        this.loadVersionList(this.form.answerid);
      }
    },
    loadForm(formid){
        this.form.xmlresult= '';
        this.$http.get('form/view', {params:{id:formid}}).then((res) => { 
            if(!res) return;
            var view = res.data.view;
                window.formViewHtml = view;
                this.editorUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
              }); 
    },
    loadAnswer(answerid,modifieddate){
        this.$http.get('subject/showsubjectformanswer',{params:{id:answerid}}).then((res) => {
        if(!res) return;
        
        this.form.answerid = res.data.answer.subjectformanswerid;
        //this.form.id = res.data.form.formid;

        var view = res.data.view;
        window.formViewHtml = view;
        this.editorUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
        }); 
    },
    loadVersionList(answerid){
      this.loadinghistory = true;
      this.$http.get('subject/answerversions',{params:{answerid:answerid}})
      .then(res=>{
        if(!res)return;
        this.history = res.data.list;

        this.viewVersionUrl ='';
        this.loadinghistory = false;

      })
    },
    loadList(){
      this.loadinganswerList = true;
      this.$http.get('subject/datagrid',{params:{id:this.form.formid,subjectid:this.subjectid}}).then((res) => {
        if(!res) return;
        this.answerList = res.data.list;
        this.loadinganswerList = false;
      }); 
    },
    showFormGrid(row){
       this.form.mode = 'grid';
       this.form.formid = row.formid;
       this.editorUrl = '';

      //caption
      this.$http.get('form/questions',{params:{id:this.form.formid}}).then((res) => {
        if(!res) return;
        this.questions = res.data.list;
       
        this.loadList();
        
      }); 
      //answerlist
    },
    onSave(){
        var str = this.$refs.iframe.contentWindow.Save();
        
        this.form.subjectid = this.subjectid;
        this.form.result = str;
        this.$http.post('subject/savesubjectformanswer', this.form).then((res) => {
            if(!res) return;

            //提醒成功
            this.$message({ type:'success', message:'保存成功'})
           
            //重新加载路由
            this.form.answerid = res.data.info["subjectformanswerid"];
            this.form.modifieddate = res.data.info["modifieddate"];
            //this.form.id = res.data.form["formid"]
            this.pageload();
 
            this.loadVersionList(this.form.answerid);
          
        }); 
    },
    pageload(){
      this.loadingsubjectFormData = true;
        this.$http.get("subject/SubjectFormRecord",
        {
          params:{subjectid:this.subjectid}
        })
        .then((res) => { 

          this.subjectFormData = res.data.list;
          
          this.totalsubjectFormAnswerCount =0;
          res.data.list.forEach((item,index)=>{
            this.totalsubjectFormAnswerCount = this.totalsubjectFormAnswerCount + parseInt(item.answercount);
          })

          this.loadingsubjectFormData = false;
        });
    },
    openFormTalbeDialog(){
      this.formTableVisible = true;
    },
    getformlist(){
      this.loadingforms = true;
      this.$http.get('subject/formlist',{params:{subjectid:this.subjectid}}).then((res) =>{
        this.tabledata_form = res.data.list;
        this.loadingforms = false;
        
      });
    },
    addformtosubject(row){
      row.subjectid = this.subjectid;
      this.$http.post('subject/addformtosubject',row).then((res)=>{
          this.getformlist();
          this.pageload();
      })
    },
    RemoveFormorAnswer(row){
      if(row.type == "form"){
        this.$confirm("确定要移除表单吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post('subject/deletesubjectform',{
                  subjectid:row.subjectid,
                  formid:row.formid
                }).then((res)=>{
                    this.getformlist();
                    this.pageload();
                })
            }, ()=>{});


        
      }
      else if(row.type == "answer"){
        this.$confirm("确定要删除数据吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post('subject/deletesubjectformanswer',{
                  subjectformanswerid:row.subjectformanswerid
                }).then((res)=>{
                    this.pageload();
                })
            }, ()=>{});
        
      }
    },
    tableRowClassName({row, rowIndex}) {
        if(row.id == this.currentRowID) return 'highlight-row'
        return '';
    },

    tabClick (tab) {
      if(tab.name == 'second'){
        if(this.radio1 != ''){
          this.getChart1();
        }
      }
    },
    draw1() {
      this.getChart1();
    },
    getChart1() {
      var myChart = this.$echarts.init(this.$refs.myChart)
      let xs = this.getChart1_X();
      myChart.setOption(
      {
        grid:{
          y2:150, //增加X轴标签的高度
        },
        tooltip: {
            trigger: 'axis'
        },
        toolbox: {
            feature: {
              restore: {},
            }
        },
        dataZoom: [
          {
              type:'slider',
              show: true,
              realtime: true,
              startValue: xs.length-15,
              endValue: xs.length,
          },
          {
              type:'inside',
              show: true,
              realtime: true,
              startValue: xs.length-15,
              endValue: xs.length,
          },
        ],
        xAxis: {
            type: 'category',
            data: xs,
            axisLabel:{
                interval:0,
                rotate:40,
              },
        },
        yAxis: {
            type: 'value'
        },
        series: [{
            name :this.subjectInfo.subjectname,
            data: this.getChart1_Y(),
            type: 'line'
        }]
      });
    },

    getChart1_X() {
      var xs = [];

      this.answerList.reverse().forEach(item => {
        xs.push(item.submitteddate);
      });

      return xs;
    },

    getChart1_Y() {
      var ys = [];
      this.answerList.reverse().forEach(item => {
        ys.push(item[this.radio1]);
      });
     

      return ys;
    },
    getAllChecked(r,q){
      r = r || [];
      if(r.length == 0) return '';

      var r1 = r[0];

      var strs = [];
      for(var i=0; i<q.fields.length; i++){
        if((r1[q.fields[i].name] || "0") == "1")
        {
            strs.push(q.fields[i].caption);
        }
      }
      return strs.join('/');
    },
    getChecked(r, v){
      r = r || [];
      if(r.length == 0) return false;
      
      return (r[0][v] || "0") == "1";
    },
    showAnswer(row, col, evt) {
      this.$http.get('subject/showsubjectformanswer',{params:{id:row.subjectformanswerid}}).then((res) => {
        if(!res) return;
        this.drawer = true;
        
        this.form.answerid = res.data.answer.subjectformanswerid;
        //this.form.id = res.data.form.formid;

        var view = res.data.view;
        window.formViewHtml = view;
        this.viewUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
        }); 
    },
    showSmartTable(row, col, evt) {
      this.drawerSmartTable = true;
    },

    getSubjectInfo(){
      this.$http.get('subject/info',
      {
        params:{subjectid:this.subjectid}
      })
      .then((res) => { 
       
        this.subjectInfo = res.data.info;
      });
    },

    //与微信用户的互动
    getWeixinConsentList(){
      this.$http.get('weixinuser/getweixinconsentsbysubjectid',{params:{subjectid:this.subjectid}}).then((res) => {
        if(!res) return;
        this.weixinconsents = res.data.list;
      }); 
    },
    showWeixinConsent(weixinconsentid) {
      this.$http.get('weixinuser/showweixinconsent',{params:{id:weixinconsentid}}).then((res) => {
          if(!res) return;
          this.drawer = true;
          var view = res.data.view;
          window.formViewHtml = view;
          this.viewUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
          }); 
    },

    openSendWeixinForm(row){
      this.weixinform.dialog = true;
      this.weixinform.formid = row.formid;
      this.weixinform.formname = row.formname;
      this.getWeixinFormList(row.formid);

      this.getSubjectFormPlanList(row.formid);


    },
    getWeixinFormList(formid){
      this.loadingsendlist = true;
      this.$http.get('weixinuser/getweixinformlist',
        {params:{subjectid:this.subjectid,formid:formid}})
        .then((res) => {
          if(!res) return;
          this.weixinform.sendlist = res.data.list;
          this.loadingsendlist = false;
        }); 
    },
    getSubjectFormPlanList(formid){
      this.loadingplanlist = true;
      //获取表单发送计划列表
      this.$http.get('subject/subjectformplanlist',
        {params:{subjectid:this.subjectid,formid:formid}})
        .then((res) => {
          if(!res) return;
          this.frequency.planlist = res.data.list;
          this.loadingplanlist = false;
        }); 
    },
    newSendWeixinFormIMM(){
      let formdate = {
        subjectid: this.subjectid,
        formid: this.weixinform.formid,
        startdate: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        enddate:this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }

      this.$http.post('weixinuser/sendweixinform',formdate)
      .then((res)=>{
        if(!res) return;
        this.getWeixinFormList(this.weixinform.formid);
      });
    },
    newSendWeixinFormPlan(){
      this.$refs.sendweixinform.validate((valid)=>{
        if(valid){
          
          this.frequency.form.subjectid = this.subjectid;
          this.frequency.form.formid = this.weixinform.formid;

          this.frequency.form.startdate = this.frequency.form.time[0];
          this.frequency.form.enddate = this.frequency.form.time[1];

          let formdata = {
            formid:this.weixinform.formid,
            subjectid:this.subjectid,
            plantype:this.frequency.form.plantype +'',
            abstract:this.frequency.form.abstract,
            startdate:this.frequency.form.startdate,
            enddate:this.frequency.form.enddate,
            freq:this.frequency.form.freq,
            intervalnum:this.frequency.form.intervalnum +'',
            until:this.frequency.form.until,
            byday:this.frequency.form.byday.join(","),
            bymonth:this.frequency.form.bymonth +'',
            bymonthday:this.frequency.form.bymonthday +'',
          };


            this.$http.post('subject/newsubjectformplan',formdata)
              .then((res)=>{
                if(!res) return;
   
                this.frequency.form.time = null;
                this.frequency.form.plantype = 0;
                // this.frequency.form = {};
                // this.frequency.form.plantype = 0;
                this.getSubjectFormPlanList(this.weixinform.formid);

                this.$message({ type:'success', message:'新增计划成功'})
              });


        }else{
          return;
        }
      });
  
    },
    deleteSubjectFormPlan(subjectformplanid){
      this.$confirm("确定要删除计划吗？","提示",{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(()=>{

        this.$http.post('subject/deletesubjectformplan',{'subjectformplanid':subjectformplanid})
        .then((res)=>{
          if(!res) return;

          this.$message({ type:'success', message:'删除计划成功'})
          this.getSubjectFormPlanList(this.weixinform.formid);

        });
      });
    },
    
    deleteWeixinForm(weixinformid){

      this.$confirm("确定取消收集吗？","提示",{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(()=>{

        this.$http.post('weixinuser/deleteweixinform',{'weixinformid':weixinformid})
        .then((res)=>{
          if(!res) return;

          this.$message({ type:'success', message:'删除计划成功'})
          this.getWeixinFormList(this.weixinform.formid);

        });
      });

    },
    remindWeixinForm(row){
      this.$http.post('weixinuser/sendweixinformhello',
        {
          'wxuserid':this.subjectInfo.weixinuserid,
          'wxformid':row.weixinformid,
        })
      .then((res)=>{
        if(!res) return;
        this.$message({ type:'success', message:'已提醒'});
      });
    },

    setfrequency(command){


      this.frequency.form.plantype = command.plantype;
      this.frequency.form.abstract = command.abstract;
      
    },
    frequencyCommand(item){
      return {plantype:item.plantype,abstract:item.abstract};
    },

    //version
      indexMethod(index) {
        return this.history.length-index;
      },
      openVersion(){
     
        this.drawerversion = true;
      },
      history_rowclick(row,event,column){
        this.$http.get('subject/showsubjectformanswerversion',{params:{id:row.indexid}}).then((res) => {
          if(!res) return;

          var view = res.data.view;
          window.formViewHtml = view;
          this.viewVersionUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
          }); 
      },
    
    
  },
  mounted () {
    if(this.form.formid || 0 != 0) this.loadForm(this.form.formid);
  
    //获取subject相关信息
    this.pageload();
    this.getformlist();

    this.getSubjectInfo();
    this.getWeixinConsentList();


    // //初始化值当前日期
    // console.log("done1..");
    // let start = new Date();
    // // this.frequency.form.time = [
    // //   start.getFullYear() + '-' + (start.getMonth()+1) + '-' + start.getDate() + ' '+  '00:00:00',
    // //   start.getFullYear() + '-' + (start.getMonth()+1) + '-' + start.getDate() +' ' +'23:59:59',
    // // ];
  },
  watch: {
      computedTime(val){
        if(val == null) return;

        let startdate = new Date(val[0]);
        
        this.frequency.list=[
            {
              plantype:0,
              abstract:'不重复',
            },
            {
              plantype:1,
              abstract:'每天',
            },
            {
              plantype:2,
              abstract:'每周一至周五',
            },
            {
              plantype:3,
              abstract:'每周六、周日',
            },
            {
              plantype:4,
              abstract:'每周(周'+ this.weekday[startdate.getDay()].name +')',
            },
            {
              plantype:5,
              abstract:'每月('+ startdate.getDate() +'日)',
            },
            // {
            //   plantype:6,
            //   abstract:'每月(第几个星期几)'',
            // },
            {
              plantype:7,
              abstract:'每年('+ (startdate.getMonth()+1) +'月'+ startdate.getDate() +'日)',
            },
            {
              plantype:99,
              abstract:'自定义',
            },
          ];


          
    
      },
      computedPlanType(val){
        let startdate='';
        if(val != 0)
        {
          startdate = new Date(this.frequency.form.time[0]);
        }
        if(this.frequency.form.freq == ""){
          this.frequency.form.freq = "WEEKLY";
          this.frequency.form.intervalnum = 1;
        }

        switch(val){
          case 0:
            this.frequency.form.freq = '';
            this.frequency.form.intervalnum =0;
            this.frequency.form.until = '';
            this.frequency.form.byday = [];
            break;
          case 1:
            this.frequency.form.freq = 'DAILY';
            this.frequency.form.intervalnum =1;
            this.frequency.form.byday = [];
            break;
          case 2:
            this.frequency.form.freq = 'WEEKLY';
            this.frequency.form.intervalnum =1;
            this.frequency.form.byday = ['MO','TU','WE','TH','FR'];
            break;
          case 3:
            this.frequency.form.freq = 'WEEKLY';
            this.frequency.form.intervalnum =1;
            this.frequency.form.byday = ['SA','SU'];
            break;
          case 4:
            this.frequency.form.freq = 'WEEKLY';
            this.frequency.form.intervalnum =1;
            this.frequency.form.byday = [this.weekday[startdate.getDay()].code];
            break;
          case 5:
            this.frequency.form.freq = 'MONTHLY';
            this.frequency.form.intervalnum =1;
            this.frequency.form.byday = [];
            this.frequency.form.bymonthday = startdate.getDay();
            break;
          case 6:
            break;
          case 7:
            
            this.frequency.form.freq = 'YEARLY';
            this.frequency.form.intervalnum =1;
            this.frequency.form.byday = [];
            this.frequency.form.bymonth = startdate.getMonth() +1;
            this.frequency.form.bymonthday = startdate.getDay();
            break;
          case 99:
            let strAbstract = "";
            
            if(this.frequency.form.byday.length ==0){
              this.frequency.form.byday = [this.weekday[startdate.getDay()].code];
            }
           

            switch(this.frequency.form.freq){
              case "DAILY":
                break;
              case "WEEKLY":
                break;
              case "MONTHLY":
                this.frequency.form.bymonthday = startdate.getDay();
                break;
              case "YEARLY":
                this.frequency.form.bymonth = startdate.getMonth() +1;
                this.frequency.form.bymonthday = startdate.getDay();
                break;
              default:
                break;

            }

            
            

            break;
          default:
            
            break;
        }
      },
      
    },
    filters: {
      ellipsis(value) {
        if (!value) return "";
        if (value.length > 11) {
          return value.slice(0, 11) + "...";
        }
        return value;
      }
    },



}




</script>

<style>

  .custom-tree-node {
    flex: 1;
    align-items: center;
    font-size: 14px;
  }

  iframe {
    width:100%;
    height:100%;
  }

  /* .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  } */

  .el-table .highlight-row {
    background: #ecf5ff;
  }

  .el-dialog__body{
    padding-top:0px;
    padding-bottom:0px;
    
  }

  .el-divider--horizontal{
    margin:2px;
  }
</style>